// Libs
import classNames from 'classnames/bind';
import { Button, Flex, Heading, IconArrowEndLine, Text, TextInput, View } from '@instructure/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// Components, Layouts, Pages
import ModalLirn from './component/ModalLirn';
// Others
import { defaultValuesForm, schema } from './helper';
import { IAccountLirn } from '~/utils/mockData/common';
// Styles, images, icons
import styles from './Lirn.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const Lirn = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/home', 'common/base']);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IAccountLirn>({
    resolver: yupResolver(schema(t)),
    defaultValues: defaultValuesForm,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const toggleShowPassword = () => {
    setIsShowPassword((show) => !show);
  };

  const handleSubmitForm = (data: IAccountLirn) => {
    // if (!data) return;

    // toggleModal();
    window.open('https://proxy.lirn.net/MiamiIntlBusUniv');
  };

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };
  //#endregion Handle Function

  return (
    <div className={cx('container')}>
      <Flex display='flex' direction='row' alignItems='center' justifyItems='center' width={'100%'}>
        <Heading level='h3'>{t('lirn_credentials_title_label')}</Heading>
      </Flex>

      <form className={cx('formLogin')} onSubmit={handleSubmit(handleSubmitForm)}>
        {/* <Controller
          name='username'
          control={control}
          render={({ field: { value, onChange } }) => (
            <TextInput
              renderLabel={t('lirn_credentials_label_username')}
              shouldNotWrap={true}
              renderBeforeInput={
                <img
                  src={icons.commonIconUsername}
                  alt={t('common_alt_img', { ns: 'common/base' })}
                  className={cx('iconInput')}
                />
              }
              value={value}
              onChange={(_, value) => {
                onChange(value);
              }}
              messages={errors?.username?.message ? [{ type: 'error', text: errors?.username?.message }] : []}
            />
          )}
        />

        <Controller
          name='password'
          control={control}
          render={({ field: { value, onChange } }) => (
            <TextInput
              renderLabel={t('lirn_credentials_label_password')}
              type={isShowPassword ? 'text' : 'password'}
              shouldNotWrap={true}
              renderBeforeInput={
                <img
                  src={icons.commonIconPassword}
                  alt={t('common_alt_img', { ns: 'common/base' })}
                  className={cx('iconInput')}
                />
              }
              renderAfterInput={
                <div onClick={toggleShowPassword}>
                  {isShowPassword ? (
                    <img
                      src={icons.commonIconHidePassword}
                      alt={t('common_alt_img', { ns: 'common/base' })}
                      className={cx('iconInput')}
                    />
                  ) : (
                    <img
                      src={icons.commonIconShowPassword}
                      alt={t('common_alt_img', { ns: 'common/base' })}
                      className={cx('iconInput')}
                    />
                  )}
                </div>
              }
              value={value}
              onChange={(_, value) => {
                onChange(value);
              }}
              messages={errors?.password?.message ? [{ type: 'error', text: errors?.password?.message }] : []}
            />
          )}
        /> */}

        <View className={cx('buttonLIRN')}>
          <Button
            color='primary'
            // margin='small 0 0 0'
            display='block'
            type='submit'
          >
            <Flex justifyItems='center' alignItems='center' gap='small'>
              <span>{t('lirn_credentials_button_title')}</span>
              <IconArrowEndLine />
            </Flex>
          </Button>
        </View>

        <ModalLirn isModalOpen={isOpenModal} onClose={toggleModal} />
      </form>

      <View margin='0 small'>
        <Text variant='content'>{t('lirn_credentials_description')}</Text>
      </View>
    </div>
  );
};

export default Lirn;
